import React from 'react';
import ExternalDoorsIframeModal from './ExternalDoorsIframeModal';

interface CalendarProps {
    onClose: () => void;
}

const Calendar: React.FC<CalendarProps> = ({ onClose }) => {
    return <ExternalDoorsIframeModal onClose={onClose} urlPath="/calendar" title="Calendar" modalPadding={10} />;
};

export default Calendar;
